<template>
  <div>
    <div class="row mt-4">
      <div class="col-12 col-lg-6">
        <h5 class="font-weight-bold text-lowercase patcraft-text-underline" :data-text="headerData.inventoryType ? (headerData.inventoryType.slice(0, 3)) : ''">
          {{ headerData.inventoryType }}
        </h5>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12 col-lg-6">
        <h3 class="font-weight-bold text-uppercase">{{ headerData.productTypeDesc }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  props:['initialSelectedFilters'],
  data() {
    return {
      header: {type: "", category: ""},
      headerData: {type: "", category: "", inventoryType: [""], productTypeDesc: [""]}
    };
  },
  computed: {
    ...mapGetters({
      selectedFilters: "filters/selectedFilters",
    }),
  },
  watch: {
    selectedFilters(newValue, oldValue) {
      if(this.headerData && newValue){
        if(newValue?.InventoryType && newValue.InventoryType.length == 1){
          this.headerData.inventoryType = newValue.InventoryType[0];

          if(newValue?.ProductTypeDesc && newValue.ProductTypeDesc.length == 1){
            this.headerData.productTypeDesc = newValue.ProductTypeDesc[0];
          }
          else{
            this.headerData.productTypeDesc = "";
          }
        }
        else{
          this.headerData.inventoryType = this.$resourceString['common.products'];
          this.headerData.productTypeDesc = ""
        }
      }
      document.title = "Patcraft | " + this.headerData.inventoryType;
    }
  },
  mounted(){
      if(this.initialSelectedFilters){
        var tempHeader = JSON.parse(this.initialSelectedFilters);
        if(tempHeader?.inventoryType && tempHeader.inventoryType.length == 1){
          this.headerData.inventoryType = tempHeader.inventoryType[0];

          if(tempHeader?.productTypeDesc && tempHeader.productTypeDesc.length == 1){
            this.headerData.productTypeDesc = tempHeader.productTypeDesc[0];
          }
          else{
            this.headerData.productTypeDesc = "";
          }
        }
        else{
          this.headerData.inventoryType = this.$resourceString['common.products'];
          this.headerData.productTypeDesc = "";
        }
      }
      const urlObj = new URL(window.location.href);
      const pathname = urlObj.pathname;
      const segments = pathname.split('/').filter(segment => segment.length > 0);
      this.header.type = (segments[segments.length - 2] != undefined && segments[segments.length - 2] != "") ? segments[segments.length - 2] : "";
      this.header.category = (segments[segments.length - 1] != undefined && segments[segments.length - 1] != "") ? segments[segments.length - 1] : "";
  },
};
</script>
